// extracted by mini-css-extract-plugin
export default {"wrapper":"h_80EWKmwZ","section":"Tveo0elt1e","header":"VFoq7X6Wy_","title":"YITzm6Eifo"};